import { Box } from '@mui/material';
import LoginForm from '../forms/LoginForm';

function LoginPage() {
  const url = "/password/forgot";

  return (
    <Box
    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}
    >
      <LoginForm />
      <Box sx={{ paddingTop: "20px" }}>
        <a
          href={url}
          target="_blank"
        >
          Forgot password?
        </a>
      </Box>
    </Box>
  );
}

export default LoginPage;